<script setup lang="ts">
import { cn } from '~/shared/lib/utils'

interface Props {
    class?: string
}

const props = withDefaults(defineProps<Props>(), {
    class: ''
})
</script>

<template>
    <td :class="cn('p-4 align-middle [&:has([role=checkbox])]:pr-0', props.class)">
        <slot />
    </td>
</template> 